//@flow

import React, { Component } from 'react';
import { Modal } from 'reactstrap';
import type { Node } from 'react';

type Props = { children: Node };

type State = { modal: boolean };
export default class HGModal extends Component<Props, State> {
  state = { modal: false };

  toggle = () => this.setState({ modal: !this.state.modal });

  render() {
    return (
      <Modal isOpen={this.state.modal} toggle={this.toggle} {...this.props}>
        {this.props.children}
      </Modal>
    );
  }
}
